export class DateMapper {
    static deserialize(dateString: string): Date | undefined {
        if (!dateString) {
            return undefined;
        }

        // Format dates as mm/dd/yyyy as JS only detects this format
        const dateSegments = dateString.split("/");
        const formattedDate = [dateSegments[1], dateSegments[0], dateSegments[2]].join("/");
        return new Date(formattedDate);
    }
}